import axios from "../../config/axiosConfig";
import { BANK_PAYMENT_REQUEST, BANK_PAYMENT_REQUEST_FAILURE, CREATE_BANK_PAYMENT, DELETE_BANK_PAYMENT,
  GET_BANK_PAYMENTS, UPDATE_BANK_PAYMENT, BANK_PAYMENT_REQUEST_SUCCESS, GET_BANK_PAYMENTS_PAGE } from "../types";

export const getBankPaymentsWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_PAYMENT_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Book_Id'
      };
      return axios.get("/bank-payment/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BANK_PAYMENTS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_PAYMENT_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_PAYMENT_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getBankPayments = (include, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_PAYMENT_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = { finyearId: fin?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/bank-payment/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BANK_PAYMENTS, payload: response?.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_PAYMENT_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_PAYMENT_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getValidatedIncrementedVchNoBankPayment = (bookId, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      if(bookId) {
        params = { ...params, bookId: bookId };
      }
      const response = await axios.get("/bank-payment/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getBankPaymentByRange = (billId, from, to, Book_Id, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      let params = {
        finyearId: fin?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to, Book_Id
      };
      
      const response = await axios.get("/bank-payment/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};


export const getBankPaymentById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_PAYMENT_REQUEST });
    
      return axios.get(`/bank-payment/get/${id}`).then((response) => {
        dispatch({ type: BANK_PAYMENT_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_PAYMENT_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_PAYMENT_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createBankPayment = (data, finyear) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      dispatch({ type: BANK_PAYMENT_REQUEST });
      return axios.post("/bank-payment/add", data,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: fin?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_BANK_PAYMENT, payload: response.data });
        } else {
          dispatch({
            type: BANK_PAYMENT_REQUEST_FAILURE,
            error: "Bank Payment create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_PAYMENT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_PAYMENT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateBankPayment = (id, data, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_PAYMENT_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      return axios.put("/bank-payment/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Payment?.Company_Id || auth.company?.id,
            finyearId: data.Payment?.Finyear_Id || fin?.id,
            customerId: data.Payment?.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_BANK_PAYMENT,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: BANK_PAYMENT_REQUEST_FAILURE,
            error: "Bank Payment update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_PAYMENT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_PAYMENT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteBankPayment = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_PAYMENT_REQUEST });
      const { auth } = getState();
      return axios.delete(`/bank-payment/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_BANK_PAYMENT, id: id });
          const include = ['id', 'Vch_No', 'Book_Id', 'Date'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { transaction: { bankPayment: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getBankPaymentsWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_PAYMENT_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_PAYMENT_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};


export const sendMailBankPayment = (mailData, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_PAYMENT_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', mailData.to);
      formData.append('templateId', mailData.templateId);
      formData.append('bankPaymentId', mailData.bankPaymentId);
      formData.append('finyearId', fin?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', mailData.recipientType || 'custom');
      formData.append('moduleName', mailData.moduleName);
      
      // Add PDF attachment if exists
      if (mailData.pdfAttachment) {
        formData.append('attachment', mailData.pdfAttachment, `bank_payment_${mailData.bankPaymentId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/bank-payment/mail-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: BANK_PAYMENT_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: BANK_PAYMENT_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: BANK_PAYMENT_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};

export const sendWhatsappBankPayment = (whatsappData, finyear) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_PAYMENT_REQUEST });
      const { auth } = getState();
      const fin = finyear || auth.finyear; 
      
      // Create FormData to handle file attachment
      const formData = new FormData();
      formData.append('to', whatsappData.to);
      formData.append('templateId', whatsappData.templateId);
      formData.append('bankPaymentId', whatsappData.bankPaymentId);
      formData.append('finyearId', fin?.id);
      formData.append('companyId', auth.company?.id);
      formData.append('customerId', auth?.user?.Customer_Id);
      formData.append('recipientType', whatsappData.recipientType || 'custom');
      
      // Add PDF attachment if exists
      if (whatsappData.pdfAttachment) {
        formData.append('attachment', whatsappData.pdfAttachment, `bank_payment_${whatsappData.bankPaymentId}.pdf`);
      }
      // console.log('formData>>',formData);
      return axios.post("/bank-payment/whatsapp-send", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        if (response.data) {
          dispatch({ type: BANK_PAYMENT_REQUEST_SUCCESS });
          return response.data;
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ 
          type: BANK_PAYMENT_REQUEST_FAILURE, 
          error: error.message 
        });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ 
        type: BANK_PAYMENT_REQUEST_FAILURE, 
        error: error.message 
      });
      throw error;
    }
  };
};